import { config as appConfig } from "/app.config"
import { PODCAST_CATEGORIES } from "@/common/constants/podcastCategories"

export const podcasts = (state) => state.podcasts

export const botPodcasts = (state) => {
  if (state.podcasts === null) return null
  return state.podcasts.filter((p) => p.podcast_type === "recording_with_ai")
}

export const botPodcastCount = (state, getters) => {
  if (getters.botPodcasts === null) return null
  return getters.botPodcasts.length
}

export const podcast = (state) => state.podcast

export const isAiPodcast = (state) => state.podcast?.podcast_type === "recording_with_ai"

export const podcastCategories = () => PODCAST_CATEGORIES

export const podcastRSSLink = (state) => {
  if (!state.podcast.key) {
    return ""
  }

  return appConfig.podcastFeedURL + state.podcast.key + "/rss"
}
